import * as T from './mediaManagementTypes';

let nextToastId = 1;

/** Resets the slice for a new outlet and loads its media. */
export const openLocation = (locationId: string) => ({
  type: T.OPEN_LOCATION as typeof T.OPEN_LOCATION,
  payload: { locationId },
});

export const loadMediaRequest = (locationId: string) => ({
  type: T.LOAD_MEDIA_REQUEST as typeof T.LOAD_MEDIA_REQUEST,
  payload: { locationId },
});

export const loadMediaSuccess = (locationId: string, data: T.LocationRichMediaResponse) => ({
  type: T.LOAD_MEDIA_SUCCESS as typeof T.LOAD_MEDIA_SUCCESS,
  payload: { locationId, data },
});

export const loadMediaFailure = (locationId: string, error: string) => ({
  type: T.LOAD_MEDIA_FAILURE as typeof T.LOAD_MEDIA_FAILURE,
  payload: { locationId, error },
});

export const loadCategoriesRequest = (locationId: string) => ({
  type: T.LOAD_CATEGORIES_REQUEST as typeof T.LOAD_CATEGORIES_REQUEST,
  payload: { locationId },
});

export const loadCategoriesSuccess = (locationId: string, categories: T.RichMediaCategory[]) => ({
  type: T.LOAD_CATEGORIES_SUCCESS as typeof T.LOAD_CATEGORIES_SUCCESS,
  payload: { locationId, categories },
});

export const loadCategoriesFailure = (locationId: string, error: string) => ({
  type: T.LOAD_CATEGORIES_FAILURE as typeof T.LOAD_CATEGORIES_FAILURE,
  payload: { locationId, error },
});

export const saveMediaRequest = (payload: T.SaveMediaPayload) => ({
  type: T.SAVE_MEDIA_REQUEST as typeof T.SAVE_MEDIA_REQUEST,
  payload,
});

export const saveMediaDone = (result: T.SaveMediaResult) => ({
  type: T.SAVE_MEDIA_DONE as typeof T.SAVE_MEDIA_DONE,
  payload: result,
});

/** `value` null clears the slot's progress. */
export const setSlotProgress = (key: string, value: number | null) => ({
  type: T.SET_SLOT_PROGRESS as typeof T.SET_SLOT_PROGRESS,
  payload: { key, value },
});

export const syncMediaRequest = (locationId: string) => ({
  type: T.SYNC_MEDIA_REQUEST as typeof T.SYNC_MEDIA_REQUEST,
  payload: { locationId },
});

export const syncMediaSuccess = () => ({
  type: T.SYNC_MEDIA_SUCCESS as typeof T.SYNC_MEDIA_SUCCESS,
});

export const syncMediaFailure = () => ({
  type: T.SYNC_MEDIA_FAILURE as typeof T.SYNC_MEDIA_FAILURE,
});

/** Reads the Kiosk Media permissions again (every visit, so a change applies without logging in again). */
export const loadMediaAccessRequest = () => ({
  type: T.LOAD_ACCESS_REQUEST as typeof T.LOAD_ACCESS_REQUEST,
});

export const loadMediaAccessDone = (access: T.KioskMediaAccess) => ({
  type: T.LOAD_ACCESS_DONE as typeof T.LOAD_ACCESS_DONE,
  payload: access,
});

export const addMediaToast = (
  message: string,
  type: T.MediaToastType = 'info',
  placement: T.MediaToast['placement'] = 'corner',
) => ({
  type: T.ADD_TOAST as typeof T.ADD_TOAST,
  payload: { id: nextToastId++, message, type, placement } as T.MediaToast,
});

export const dismissMediaToast = (id: number) => ({
  type: T.DISMISS_TOAST as typeof T.DISMISS_TOAST,
  payload: id,
});

export type MediaManagementAction =
  | ReturnType<typeof openLocation>
  | ReturnType<typeof loadMediaRequest>
  | ReturnType<typeof loadMediaSuccess>
  | ReturnType<typeof loadMediaFailure>
  | ReturnType<typeof loadCategoriesRequest>
  | ReturnType<typeof loadCategoriesSuccess>
  | ReturnType<typeof loadCategoriesFailure>
  | ReturnType<typeof saveMediaRequest>
  | ReturnType<typeof saveMediaDone>
  | ReturnType<typeof setSlotProgress>
  | ReturnType<typeof syncMediaRequest>
  | ReturnType<typeof syncMediaSuccess>
  | ReturnType<typeof syncMediaFailure>
  | ReturnType<typeof loadMediaAccessRequest>
  | ReturnType<typeof loadMediaAccessDone>
  | ReturnType<typeof addMediaToast>
  | ReturnType<typeof dismissMediaToast>;
